import { InformationUnitSkeleton } from '@acceso/design-system';

export function GeneralLoading() {
  return (
    <div className="w-full animate-fade-in-down space-y-4 duration-200">
      {[...Array(5)].map((_, index) => (
        <InformationUnitSkeleton isEven={index % 2 == 0} key={index} />
      ))}
    </div>
  );
}
